var map = {
	"./1.png": 1503,
	"./5.png": 6923,
	"./7.png": 1881,
	"./WhatsApp Image 2025-09-12 at 16.52.44.jpeg": 1968,
	"./WhatsApp Image 2025-09-15 at 11.35.20.jpeg": 5180,
	"./WhatsApp Image 2025-09-15 at 11.52.26 (1).jpeg": 8786,
	"./WhatsApp Image 2025-09-15 at 11.52.26 (2).jpeg": 6893,
	"./WhatsApp Image 2025-09-15 at 11.52.26 (3).jpeg": 9232,
	"./WhatsApp Image 2025-09-15 at 11.52.26 (4).jpeg": 1355,
	"./WhatsApp Image 2025-09-15 at 11.52.26 (5).jpeg": 7278,
	"./WhatsApp Image 2025-09-15 at 11.52.26.jpeg": 1768
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1631;